import { AppConfig } from "../models/app-config.model";

export namespace AppConfigActions {
    export class Set {
        static readonly type = '[API-AppConfig] Set'
        constructor(public payload: AppConfig) {}
    }
}
